import { useParams } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'

import { showError } from 'Shared/Components/NotifyToast'
import { webUrl } from "Shared/utils"

const useFetchData = () => {
  const { getAccessTokenSilently, logout } = useAuth0()
  const routeParam = useParams()

  const getToken = async () => {
    try {
      const res = await getAccessTokenSilently({
        scope: "openid offline_access",
        grant: "refresh_token",
        detailedResponse: true
      })

      const token = res.access_token

      if (token != localStorage.getItem("access_token")) {
        localStorage.setItem('access_token', token)
        window.dispatchEvent(new Event('access_token_change'));
      }

      return token
    }
    catch (e){
      logout({ logoutParams: { returnTo: webUrl } })
    }
  }

  const send = async ({ method, url, params, headers, body, contentType, returnType }) => {
    let accessToken = await getToken()
    
    const defaultHeader = {
      'Authorization': accessToken,
      'Project': routeParam.project
    }

    if (contentType === "json") {
      defaultHeader['Content-Type'] = "application/json"
      body = JSON.stringify(body)
    }
    
    try {
      const res = await fetch(`${url}${params ? `?${new URLSearchParams(params)}` : ""}`, {
        method: method,
        headers: headers ?? defaultHeader,
        body: body
      })

      if (res.status === 200) {
        switch(returnType) {
          case "json":
            return await res.json()
          case "blob":
            return await res.blob()
          default:
            return res
        }
      }
      else {
        if (res.status === 401 || res.status === 403) {
          logout({ logoutParams: { returnTo: webUrl } })
        }

        body = await res.text()

        try {
          showError(`${JSON.parse(body)["message"]}`)
        }
        catch {
          showError(body)
        }
        
        return null
      }
    }
    catch (error) {
      showError(`${error}`)
      return null
    }
  }

  return { send }
}

export default useFetchData
